import React from 'react';
import Anatomy from '../../features/anatomy/Anatomy';
import Anatomy1 from '../../features/anatomy/Anatomy1';
import { ThemeProvider } from '@mui/material';
import theme from '../../themes/theme';
import Anatomy2 from '../../features/anatomy/Anatomy2';

const AnatomyPage = () => {
    return (
        <>
            <ThemeProvider theme={theme}>
               {/* <Anatomy1 /> */}
                <Anatomy2 />
            </ThemeProvider>
        </>
    );
};

export default AnatomyPage;
